import { createContext } from 'react'

export interface IOtaAppContext {
  isOta: boolean
}

export const OtaAppContext = createContext<IOtaAppContext>({ isOta: false })
